/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WaitlistRouteImport } from './routes/waitlist'
import { Route as ReportBugRouteImport } from './routes/report-bug'
import { Route as PluginsRouteImport } from './routes/plugins'
import { Route as FoundingMemberRouteImport } from './routes/founding-member'
import { Route as IndexRouteImport } from './routes/index'

const WaitlistRoute = WaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportBugRoute = ReportBugRouteImport.update({
  id: '/report-bug',
  path: '/report-bug',
  getParentRoute: () => rootRouteImport,
} as any)
const PluginsRoute = PluginsRouteImport.update({
  id: '/plugins',
  path: '/plugins',
  getParentRoute: () => rootRouteImport,
} as any)
const FoundingMemberRoute = FoundingMemberRouteImport.update({
  id: '/founding-member',
  path: '/founding-member',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/founding-member': typeof FoundingMemberRoute
  '/plugins': typeof PluginsRoute
  '/report-bug': typeof ReportBugRoute
  '/waitlist': typeof WaitlistRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/founding-member': typeof FoundingMemberRoute
  '/plugins': typeof PluginsRoute
  '/report-bug': typeof ReportBugRoute
  '/waitlist': typeof WaitlistRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/founding-member': typeof FoundingMemberRoute
  '/plugins': typeof PluginsRoute
  '/report-bug': typeof ReportBugRoute
  '/waitlist': typeof WaitlistRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/founding-member' | '/plugins' | '/report-bug' | '/waitlist'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/founding-member' | '/plugins' | '/report-bug' | '/waitlist'
  id:
    | '__root__'
    | '/'
    | '/founding-member'
    | '/plugins'
    | '/report-bug'
    | '/waitlist'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  FoundingMemberRoute: typeof FoundingMemberRoute
  PluginsRoute: typeof PluginsRoute
  ReportBugRoute: typeof ReportBugRoute
  WaitlistRoute: typeof WaitlistRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/waitlist': {
      id: '/waitlist'
      path: '/waitlist'
      fullPath: '/waitlist'
      preLoaderRoute: typeof WaitlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/report-bug': {
      id: '/report-bug'
      path: '/report-bug'
      fullPath: '/report-bug'
      preLoaderRoute: typeof ReportBugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plugins': {
      id: '/plugins'
      path: '/plugins'
      fullPath: '/plugins'
      preLoaderRoute: typeof PluginsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/founding-member': {
      id: '/founding-member'
      path: '/founding-member'
      fullPath: '/founding-member'
      preLoaderRoute: typeof FoundingMemberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  FoundingMemberRoute: FoundingMemberRoute,
  PluginsRoute: PluginsRoute,
  ReportBugRoute: ReportBugRoute,
  WaitlistRoute: WaitlistRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
